<template>
    <section :class="{'px-6 md:px-8 pb-8': !horizontal}">
    
        <section :class="formStyles">
          <section class="flex flex-col pb-20-px gap-y-4 ">
            <section class="flex flex-col gap-y-4" :class="{'md:flex-row': horizontal}">

              <input-field
                  :inputStyles="inputStyles"
                  class="mr-50px"
                  :class="{'md:mr-6': horizontal}"
                  identity="Nombre"
                  ref="firstName"
                  placeholder="Nombre"
                  v-model="contactData.firstName"
                  :isBig="false"
                  :rules="{
                  required: true,
                  }"
              />
              <input-field
              :inputStyles="inputStyles"
                  identity="Apellido"
                  ref="lastName"
                  placeholder="Apellidos"
                  v-model="contactData.lastName"
                  :isBig="false"
                  :rules="{
                  required: true,
                  }"
            />
            </section>

            <section class="flex flex-col gap-y-6" :class="{'md:flex-row': horizontal}">

              <section class="w-full " 
                  :class="horizontal ? 'md:mr-6' : 'md:mr-50px'">

                  <vue-phone-number-input
                      class="pl-6px rounded-xl"
                      size="lg"
                      :class="{'text-skin-check-box bg-skin-check_inactive ': inputStyles, 'bg-white': !inputStyles} "
                      :translations="{phoneNumberLabel:'Teléfono'}"
                      :default-country-code="codeCountry"
                      :border-radius="20"
                      :no-example="true"
                      no-validator-state
                      :placeholder="'Telefono'"
                      show-code-on-list
                      valid-color="#e5e7eb"
                      error-color="#e5e7eb"
                      color="#fff"
                      ref="phone"
                      identity="Teléfono"
                      v-model="contactData.phone"
                      :rules="{
                      required: true,
                      numeric: true,
                      }"
                      v-if="showVuePhone"
                  />
              </section>

              <input-field
              :inputStyles="inputStyles"
                  identity="Email"
                  ref="email"
                  placeholder="Correo electrónico"
                  v-model="contactData.email"
                  :isBig="false"
                  :rules="{
                  required: true,
                  email: true,
                  }"
              />
            </section>
          </section>
          <section class=" md:pt-0   " 
          :class="{'md:mt-3 lg:-mt-3 ': horizontal, 'md:ml-6 pt-16px': marginRecaptcha }"
          >
              <section v-if="gRecaptcha" :class="topRecaptcha" class="w-full" >
                <g-recaptcha
                  :data-sitekey="sitekey"
                  :data-validate="validateRecaptcha"
                  :data-callback="sendUserData"
                  data-language="es-419"
                  data-size
                  data-btn-class="w-full"
                  class="flex flex-col "
                  :class="formDirection"
                >
    
                <button
                  class="mt-3 text-lg bg-black text-white font-bold rounded-xl   lg:w-80 h-14"
                  :class="[buttonStyle, btnSize, {'opacity-70': isLoading}]"
                >
                  <span v-text="!isLoading ? buttonText : 'Enviando...'"/>
    
                </button>
    
                </g-recaptcha>

              </section>
            <section v-if="!gRecaptcha" >
             <main-button  @click="sendUserData(null, false)" :text="buttonText.buttonText" class="lg:w-full" :class="[buttonStyle, {'opacity-75': isLoading}]" />
            </section>
          </section>
        </section>
        <p class="text-sm pt-4 text-center"  v-text="secondText" :class="textStyle"/>
    </section>
</template>

<script>
import gRecaptcha from "@finpo/vue2-recaptcha-invisible";
import axios from "axios";
import utilsMixin from "../mixins/utilsMixin"
import toastr from "toastr";
import InputField from "./InputField.vue"
import VuePhoneNumberInput from "vue-phone-number-input"
import MainButton from "./MainButton.vue"

export default {
  mixins: [utilsMixin],
  components: {
     gRecaptcha,
    InputField,
    VuePhoneNumberInput,
    MainButton
  },
  data: () => ({
    sitekey: process.env.VUE_APP_RECAPTCHA,
    contactData: {
      firstName: null,
      lastName: null,
      phone: null,
      email: null,
      ip: null,
      town: null,
      country: null,
      colReverse: false,
    },
    isLoading: false,
    codeCountry: 'ES',
    showVuePhone:false,
  }),
  
  props:{
    buttonText:{},
    buttonStyle:{},
    landing:{},
    secondText:{},
    btnSize:{},
    textStyle:{},
    pagePush:{
      default:'thanks'
    },
    topRecaptcha:{default:''},
    formDirection:{default:'items-center'},
    formStyles:{
      default: 'lg:flex lg:flex-row gap-y-2.5 pt-7 lg:pt-3.5'
    },
    marginRecaptcha:{default:true},
    inputStyles: {default: true},
    gRecaptcha: {defautl: true},
    horizontal:{
      type:Boolean,
      default: false
    }
    
  },
  mounted (){
    if(localStorage.getItem("firstName")) this.firstName = JSON.parse(localStorage.getItem("firstName"));
    if(localStorage.getItem("lastName")) this.lastName = JSON.parse(localStorage.getItem("lastName"));
    if(localStorage.getItem("phone")) this.phone = JSON.parse(localStorage.getItem("phone"));
    if(localStorage.getItem("email")) this.email = JSON.parse(localStorage.getItem("email"));

    this.getIpAddress();
  },
  methods:{
    validateRecaptcha() {
      return true;
    },
    callback(token) {
      if (token) {
        return false;
      } else {
        toastr.error("Por favor, verifique que no es un robot");
        return true;
      }
    }, 
    validate(){
      const firstName = this.$refs.firstName.validate();
      const lastName = this.$refs.lastName.validate();
      const email = this.$refs.email.validate();

      if(firstName || lastName  || email  ) 
      toastr.error(
        "Todos los campos son requeridos, por favor revise la información ingresada."
      );
      return (firstName || lastName  || email )
      
    },
    goToModalForm() {
      if (!this.validate()) {
        this.changeShowModal(true);
      }
    },
    async sendUserData(token) {

      if (this.validate() || this.callback(token) || this.isLoading) return;
      this.isLoading = true;

      if(this.contactData.ip == null){
        await this.getIpAddress()
      }


      const requestAuthorization = await axios.post("/oauth/token", {
          grant_type: "client_credentials",
          client_secret: process.env.VUE_APP_CLIENT_AP,
          client_id: process.env.VUE_APP_CLIENT_ID,
      });

      axios.defaults.headers.common["Authorization"] = `Bearer ${
          requestAuthorization.data.access_token
      }`;
      const requestDataPerson = await axios.post("/api/v1/contact-leads", {
          name: this.contactData.firstName,
          last_name: this.contactData.lastName,
          movil: this.contactData.phone,
          landing_id: this.landing,
          ip: this.contactData.ip,
          town: this.contactData.town,
          country: this.contactData.country,
          proyect_id: process.env.VUE_APP_PROYECT_ID,
          email: this.contactData.email,
      });

      if (requestDataPerson.data.success) {

          this.$emit("send");
          this.isThereRequestError = false;
          toastr.success(requestDataPerson.data.message);
          this.isLoading = false;
          this.$router.push({
          name: this.pagePush
          });
      } else {
          this.isThereRequestError = true;
          toastr.error(requestDataPerson.data.message);
          this.isLoading = false;
      }
    },
    async getIpAddress() {
      let url = "https://ipapi.co/json/";
      const response = await axios.get(url);
      this.contactData.ip = response.data.ip;
      this.contactData.town = response.data.city;
      this.contactData.country = response.data.country_name;
      this.codeCountry = response.data.country
      this.showVuePhone = true
    },
  },
  watch: {
    'contactData.phone': function (newValue){
      localStorage.setItem('phone', newValue)
      },
      'contactData.firstName': function (newValue){
        localStorage.setItem('firstName', newValue)
      },
      'contactData.lastName': function(newValue){
        localStorage.setItem('lastName', newValue)
      },
      'contactData.email': function (newValue){
        localStorage.setItem('email', newValue)
      }
  },
}
</script>
<style >
.vue-phone-number-input{
  height: 56px;
  align-items: center;
}
.box-shadow{
  box-shadow: 0px 1px 2px rgb(0 0 0 / 24%), 0px 1px 2px rgb(0 0 0 / 12%);
  
}
#VuePhoneNumberInput_country_selector{
  border: none;
}
#VuePhoneNumberInput_phone_number{
  border: none;
}
</style>
